module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup popup-goods"
  }, [_c('header', {
    staticClass: "bar bar-nav close-popup"
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [(_vm.$route.query.id) ? _c('div', {
    staticStyle: {
      "color": "#c82829"
    }
  }, [(_vm.$route.query.label) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.$route.query.label) + "查询\n        ")]) : _c('div', [_vm._v("促销查询")])]) : _c('div', [_vm._v("搜索查询")])])]), _vm._v(" "), _c('div', {
    staticClass: "bar bar-header-secondary"
  }, [_c('div', {
    staticClass: "searchbar"
  }, [_c('a', {
    staticClass: "searchbar-cancel close-popup"
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "searchGoods"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.queryName),
      expression: "queryName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "id": "searchGoods",
      "placeholder": "查询基因/病毒/功能..."
    },
    domProps: {
      "value": (_vm.queryName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), (_vm.showMatchData) ? _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "4.5rem"
    }
  }, [_c('ul', {
    attrs: {
      "id": "list"
    }
  }, _vm._l((_vm.matchData), function(searchData) {
    return _c('li', {
      staticClass: "item-content close-popup"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.searchTarget(searchData, true)
        }
      }
    }, [_c('div', {
      staticClass: "item-title close-popup",
      attrs: {
        "id": "results-goods"
      }
    }, [_vm._v("\n            " + _vm._s(searchData.data.word) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, _vm._l((searchData.tags), function(tag) {
      return _c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(tag))])
    }), 0)])])
  }), 0)]) : _c('div', {
    staticClass: "content infinite-scroll-top",
    attrs: {
      "data-distance": "5"
    }
  }, [(_vm.searchHistory.length && _vm.searchHistory) ? _c('div', {
    staticClass: "search_history"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('div', {
    staticClass: "blueTitle"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("搜索历史")]), _vm._v(" "), _c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "-1.2rem",
      "margin-left": "86%",
      "color": "#f6383a"
    },
    on: {
      "click": _vm.removeSearchHistory
    }
  }, [_vm._v("清空")]), _vm._v(" "), _vm._l((_vm.searchHistory), function(item, index) {
    return (!_vm.isRemoveSH) ? _c('li', {
      staticClass: "item-content close-popup"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.searchTarget(item, false)
        }
      }
    }, [_c('div', {
      staticClass: "item-title close-popup"
    }, [_vm._v("\n               " + _vm._s(item.data.word) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, _vm._l((item.tags), function(tag) {
      return _c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(tag))])
    }), 0)])]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.hotWordList && _vm.hotWordList.length > 0) ? _c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('div', {
    staticClass: "blueTitle"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("热门搜索")]), _vm._v(" "), _vm._l((_vm.hotWordList), function(item) {
    return _c('li', {
      staticClass: "item-content close-popup"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.searchTarget(item, false)
        }
      }
    }, [_c('div', {
      staticClass: "item-title close-popup"
    }, [_vm._v("\n              " + _vm._s(item.data.word) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, _vm._l((item.tags), function(tag) {
      return _c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(tag))])
    }), 0)])])
  })], 2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button button-link button-nav pull-left close-popup"
  }, [_c('span', {
    staticClass: "icon icon-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc367b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/SearchBox.vue
// module id = 1624
// module chunks = 8